// extracted by mini-css-extract-plugin
module.exports = {"card":"Forms_card__2PoNH","delete":"Forms_delete__eyUZw","append":"Forms_append__3ZHvf","text":"Forms_text__mKVjT","containerForm":"Forms_containerForm__DSHZE"};